package one.healthium.ui.compose.platform

import androidx.compose.runtime.Composable

@Composable
actual fun PlatformColorsEffect(lightStatusBar: Boolean) {
}